import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {DefaultFilter} from '@mominsamir/ngx-smart-table';
import {FormControl, Validators} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
    template: `
        <input
            [class.pointer-none]="disabled"
            class="form-control"
            style="transition-duration: 0s"
            placeholder="{{ column.title }}"
            [formControl]="inputControl"
        />
    `,
})
export class InputFilterComponent extends DefaultFilter implements OnInit, OnChanges, OnDestroy {
    inputControl: FormControl = new FormControl('', [Validators.maxLength(200)]);

    inputControlSubscription: Subscription;

    // Used only to visually pre-fill the input; does not trigger table updates.
    // Should be used together with @initFilter from ngx-data-table.
    // See: https://engineeredintelligence.myjetbrains.com/youtrack/articles/ENGIN-A-485/Initial-Table-Filtering-ngx-data-table
    preSelectedValue: string;
    disabled: boolean;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.inputControlSubscription = this.inputControl.valueChanges
            .pipe(distinctUntilChanged(), debounceTime(this.delay))
            .subscribe((value: string) => {
                this.query = encodeURIComponent(value) || '';
                this.setFilter();
            });

        this.preSelectedValue = this.column?.filter?.config?.preSelectedValue;
        if (this.preSelectedValue) this.inputControl.setValue(this.preSelectedValue, {emitEvent: false});

        this.disabled = this.column?.filter?.config?.disabled || false;
        if (this.disabled) this.inputControl.disable();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();

        if (this.inputControlSubscription) {
            this.inputControlSubscription.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.query) {
            this.query = changes.query.currentValue;
            this.inputControl.setValue(this.inputControl.value);
        }
    }
}
